module.exports = __webpack_public_path__ + "static/media/cspinner.1901e1b6.gif";